export const ToeflWordList = [
  
  { word: "abundant", wordInfo: "present in large quantities" },
  { word: "accumulate", wordInfo: "to gradually collect" },
  { word: "accurate", wordInfo: "correct; free from errors" },
  { word: "accustomed", wordInfo: "used to something" },
  { word: "acquire", wordInfo: "to come into possession of" },
  { word: "adamant", wordInfo: "refusing to change an opinion" },
  { word: "adequate", wordInfo: "enough to suit your needs" },
  { word: "adjacent", wordInfo: "close to or next to" },
  {
    word: "adjust",
    wordInfo: "to change something so it serves its purpose better",
  },
  {
    word: "advantage",
    wordInfo: "something that makes it easier to achieve success",
  },
  { word: "advocate", wordInfo: "to publicly support" },
  { word: "adverse", wordInfo: "unfavorable; against oneâ€™s desires" },
  { word: "aggregate", wordInfo: "to combine" },
  { word: "aggressive", wordInfo: "assertive and pushy" },
  { word: "allocate", wordInfo: "to put aside for a specific purpose" },
  { word: "alternative", wordInfo: "another option or choice" },
  {
    word: "amateur",
    wordInfo: "someone who is inexperienced or not highly skilled in a",
  },
  {
    word: "ambiguous",
    wordInfo: "having several potential meanings; unclear and difficult to",
  },
  { word: "ambitious", wordInfo: "having large goals" },
  { word: "amend", wordInfo: "to change for the better; to improve" },
  { word: "ample", wordInfo: "plentiful" },
  { word: "anomaly", wordInfo: "deviation from the norm" },
  { word: "annual", wordInfo: "occurring yearly" },
  {
    word: "antagonize",
    wordInfo: "to tease or be hostile towards a person or group",
  },
  { word: "attitude", wordInfo: "manner or feeling" },
  { word: "attribute", wordInfo: "to give credit" },
  { word: "arbitrary", wordInfo: "based on a whim or random desire" },
  { word: "arduous", wordInfo: "requiring a lot of effort" },
  { word: "assuage", wordInfo: "to lessen a negative feeling" },
  { word: "assume", wordInfo: "to suppose without solid proof" },
  { word: "augment", wordInfo: "to increase or make larger" },
  { word: "benefit", wordInfo: "something positive or advantageous" },
  { word: "berate", wordInfo: "to scold" },
  { word: "bestow", wordInfo: "to give as a gift" },
  { word: "boast", wordInfo: "to brag or talk with excessive pride" },
  { word: "boost", wordInfo: "to help raise or increase something" },
  { word: "brash", wordInfo: "rude and tactless" },
  { word: "brief", wordInfo: "short (in terms of time)" },
  { word: "brusque", wordInfo: "abrupt to the point of rudeness" },
  { word: "cacophony", wordInfo: "a harsh, unpleasant mixture of noise" },
  { word: "cease", wordInfo: "to stop" },
  { word: "censure", wordInfo: "to express strong disapproval" },
  { word: "chronological", wordInfo: "arranged in order of time or date" },
  { word: "clarify", wordInfo: "to make clear; to remove confusion" },
  { word: "coalesce", wordInfo: "to combine or grow together" },
  {
    word: "coerce",
    wordInfo: "to force someone to do something against their will",
  },
  {
    word: "cognizant",
    wordInfo: "being aware or having knowledge of something",
  },
  { word: "cohesion", wordInfo: "uniting; becoming one" },
  { word: "coincide", wordInfo: "to occur at the same time" },
  { word: "collapse", wordInfo: "to fall down or break down" },
  { word: "collide", wordInfo: "to hit one another with a forceful impact" },
  { word: "commitment", wordInfo: "dedication to a cause or activity" },
  {
    word: "community",
    wordInfo: "a group of people who live or work together",
  },
  { word: "conceal", wordInfo: "to hide" },
  { word: "concur", wordInfo: "to agree" },
  { word: "conflict", wordInfo: "a disagreement or fight" },
  { word: "constrain", wordInfo: "to restrict or repress" },
  { word: "contemplate", wordInfo: "to consider thoughtfully" },
  { word: "continuously", wordInfo: "to go on without stopping" },
  { word: "contradict", wordInfo: "to give the opposite opinion" },
  {
    word: "contribute",
    wordInfo: "to give something (usually money or time) to a common fund or",
  },
  { word: "convey", wordInfo: "to make known" },
  { word: "copious", wordInfo: "abundant" },
  { word: "core", wordInfo: "central; of main importance" },
  { word: "corrode", wordInfo: "to gradually wear away" },
  { word: "cumbersome", wordInfo: "burdensome; clumsy" },
  { word: "curriculum", wordInfo: "the courses given by a school or program" },
  { word: "data", wordInfo: "facts, statistics, or pieces of information" },
  { word: "decay", wordInfo: "to decline in health or excellence" },
  { word: "deceive", wordInfo: "to trick or mislead" },
  { word: "decipher", wordInfo: "to find the meaning of" },
  { word: "declaration", wordInfo: "an announcement" },
  { word: "decline", wordInfo: "to politely refuse" },
  { word: "degrade", wordInfo: "to lower in quality" },
  { word: "demonstrate", wordInfo: "to show" },
  { word: "deny", wordInfo: "to state that something isnâ€™t true" },
  { word: "deplete", wordInfo: "to significantly decrease" },
  { word: "deposit", wordInfo: "to deliver and leave an item" },
  { word: "desirable", wordInfo: "worth having or wanting" },
  { word: "despise", wordInfo: "to hate" },
  { word: "detect", wordInfo: "to locate something" },
  { word: "deter", wordInfo: "to discourage" },
  { word: "deviate", wordInfo: "to differ from the norm" },
  { word: "devise", wordInfo: "to plan or create" },
  { word: "diatribe", wordInfo: "a sharp criticism or attack" },
  { word: "digress", wordInfo: "to wander from the main subject" },
  {
    word: "dilemma",
    wordInfo: "a situation where one must choose between two difficult choices",
  },
  { word: "diminish", wordInfo: "to shrink or reduce" },
  { word: "dispose", wordInfo: "to get rid of" },
  {
    word: "disproportionate",
    wordInfo: "too small or large when compared to something else",
  },
  { word: "disrupt", wordInfo: "to interrupt by causing a disturbance" },
  { word: "distort", wordInfo: "to misrepresent" },
  { word: "distribute", wordInfo: "to give portions of something" },
  { word: "diverse", wordInfo: "showing a lot of variety" },
  { word: "divert", wordInfo: "to cause a change of course" },
  { word: "dynamic", wordInfo: "constantly changing" },
  { word: "ease", wordInfo: "to reduce unpleasantness or difficulty" },
  { word: "efficient", wordInfo: "maximizing productivity" },
  { word: "eliminate", wordInfo: "to remove" },
  { word: "elite", wordInfo: "a select, above-average group" },
  { word: "eloquent", wordInfo: "moving speech or writing" },
  {
    word: "emphasize",
    wordInfo: "to give special importance to when speaking or writing",
  },
  {
    word: "endure",
    wordInfo: "to suffer through something difficult with patience",
  },
  { word: "enhance", wordInfo: "to intensify or magnify" },
  { word: "epitome", wordInfo: "a perfect example of something" },
  { word: "equivalent", wordInfo: "equal" },
  { word: "erroneous", wordInfo: "incorrect" },
  { word: "estimate", wordInfo: "an approximate value" },
  { word: "evade", wordInfo: "to avoid or escape" },
  { word: "evaluate", wordInfo: "to assess" },
  {
    word: "evidence",
    wordInfo: "facts or evidence that help prove or disprove something",
  },
  { word: "evolve", wordInfo: "to gradually change" },
  { word: "exemplary", wordInfo: "worthy of imitation" },
  { word: "exclude", wordInfo: "to leave out" },
  { word: "exclusive", wordInfo: "not admitting the majority" },
  { word: "expand", wordInfo: "to increase in size" },
  {
    word: "expertise",
    wordInfo: "expert knowledge or skill in a particular field",
  },
  { word: "exploit", wordInfo: "to use selfishly" },
  { word: "expose", wordInfo: "to reveal or unmask" },
  { word: "extension", wordInfo: "an act of making something longer" },
  { word: "extract", wordInfo: "to get or remove something" },
  { word: "famine", wordInfo: "a time when there is an extreme lack of food" },
  { word: "feasible", wordInfo: "possible to do" },
  { word: "finite", wordInfo: "having an end or limits" },
  {
    word: "flaw",
    wordInfo: "a feature that ruins the perfection of something",
  },
  { word: "fluctuate", wordInfo: "to change continually" },
  { word: "focus", wordInfo: "the central point or idea" },
  { word: "fortify", wordInfo: "to strengthen" },
  {
    word: "framework",
    wordInfo: "a skeletal structure designed to support something",
  },
  { word: "frivolous", wordInfo: "unnecessary; of little importance" },
  { word: "function", wordInfo: "a purpose natural to a person or thing" },
  { word: "fundamental", wordInfo: "of primary importance" },
  { word: "gap", wordInfo: "a space in between two objects" },
  { word: "garbled", wordInfo: "communication that is distorted and unclear" },
  { word: "generate", wordInfo: "to produce" },
  { word: "grandiose", wordInfo: "pompous; overly important" },
  { word: "hackneyed", wordInfo: "overused and unoriginal" },
  { word: "haphazard", wordInfo: "lacking planning" },
  { word: "harsh", wordInfo: "not gentle; unpleasant" },
  { word: "hasty", wordInfo: "in a hurry" },
  { word: "hazardous", wordInfo: "full of risk" },
  { word: "hesitate", wordInfo: "to pause, often due to reluctance" },
  { word: "hierarchy", wordInfo: "a ranking system" },
  { word: "hindrance", wordInfo: "something that causes delay or resistance" },
  { word: "hollow", wordInfo: "empty inside" },
  { word: "horror", wordInfo: "an intense feeling of fear" },
  { word: "hostile", wordInfo: "extremely unfriendly" },
  {
    word: "hypothesis",
    wordInfo: "an unproven idea that attempts to prove something",
  },
  { word: "identical", wordInfo: "exactly the same" },
  { word: "illiterate", wordInfo: "unable to read" },
  { word: "illustrate", wordInfo: "to explain by using an example" },
  { word: "impact", wordInfo: "effect or influence" },
  { word: "impair", wordInfo: "to worsen" },
  { word: "implement", wordInfo: "to carry out" },
  { word: "imply", wordInfo: "to strongly suggest" },
  { word: "impose", wordInfo: "to force upon" },
  { word: "impoverish", wordInfo: "to reduce to poverty" },
  { word: "incentive", wordInfo: "a reason to do something" },
  { word: "incessant", wordInfo: "continuing without pause" },
  { word: "incidental", wordInfo: "a minor part" },
  { word: "incite", wordInfo: "to urge on" },
  { word: "inclination", wordInfo: "a preference" },
  { word: "incompetent", wordInfo: "incapable; lacking ability" },
  { word: "inconsistent", wordInfo: "changing randomly" },
  { word: "indefatigable", wordInfo: "untiring" },
  { word: "indisputable", wordInfo: "not able to be challenged" },
  { word: "ineffective", wordInfo: "not producing any major impact" },
  { word: "inevitable", wordInfo: "unable to be avoided" },
  { word: "infer", wordInfo: "to guess based on evidence" },
  { word: "inflate", wordInfo: "to increase in size" },
  { word: "influence", wordInfo: "the ability to have an impact on something" },
  { word: "inhibit", wordInfo: "to hinder or restrain" },
  { word: "initial", wordInfo: "the first" },
  { word: "inquiry", wordInfo: "an investigation to determine the truth" },
  { word: "integral", wordInfo: "necessary to complete the whole" },
  { word: "integrate", wordInfo: "to combine" },
  { word: "interpret", wordInfo: "to explain the meaning of something" },
  {
    word: "intervene",
    wordInfo: "to come between people, objects, or an event and change what",
  },
  { word: "intrepid", wordInfo: "fearless" },
  { word: "intricate", wordInfo: "highly detailed" },
  { word: "invasive", wordInfo: "intrusive" },
  { word: "investigate", wordInfo: "to examine or study" },
  { word: "irascible", wordInfo: "easy to anger" },
  {
    word: "irony",
    wordInfo: "the use of words to give a meaning opposite to their literal",
  },
  { word: "irresolute", wordInfo: "uncertain" },
  { word: "jargon", wordInfo: "words specific to a certain job or group" },
  { word: "jointly", wordInfo: "together" },
  { word: "knack", wordInfo: "a special talent or skill" },
  { word: "labor", wordInfo: "work or effort" },
  { word: "lag", wordInfo: "to fall behind" },
  { word: "lampoon", wordInfo: "to mock or ridicule" },
  { word: "languish", wordInfo: "to become weak" },
  { word: "lecture", wordInfo: "a talk given to an audience" },
  { word: "leery", wordInfo: "wary" },
  { word: "legitimate", wordInfo: "lawful" },
  { word: "lenient", wordInfo: "merciful; less harsh" },
  { word: "likely", wordInfo: "probable" },
  { word: "ludicrous", wordInfo: "ridiculous" },
  { word: "maintain", wordInfo: "to continue at the same level" },
  { word: "major", wordInfo: "very important" },
  { word: "manipulate", wordInfo: "to influence, especially in an unfair way" },
  { word: "maximize", wordInfo: "to increase to the greatest possible size" },
  { word: "measure", wordInfo: "to find the size and dimensions of something" },
  { word: "mediocre", wordInfo: "ordinary, average" },
  { word: "mend", wordInfo: "to fix" },
  { word: "method", wordInfo: "a way of doing something" },
  { word: "migrate", wordInfo: "to move from one place to another" },
  { word: "minimum", wordInfo: "the smallest or lowest amount possible" },
  { word: "misleading", wordInfo: "giving the wrong idea" },
  { word: "modify", wordInfo: "to change" },
  { word: "morose", wordInfo: "gloomy, depressed" },
  { word: "negligent", wordInfo: "lazy, neglectful" },
  { word: "nonchalant", wordInfo: "indifferent, unexcited" },
  { word: "obey", wordInfo: "to follow orders or instructions" },
  { word: "obtain", wordInfo: "to get" },
  { word: "obvious", wordInfo: "easily understood" },
  {
    word: "opponent",
    wordInfo: "someone on the opposite side for a game or contest",
  },
  { word: "oppress", wordInfo: "to unfairly burden" },
  { word: "origin", wordInfo: "the source; where something began" },
  { word: "parsimonious", wordInfo: "frugal, stingy" },
  { word: "partake", wordInfo: "to join in" },
  { word: "partial", wordInfo: "preferring one option over others" },
  {
    word: "paucity",
    wordInfo: "something existing in very small amounts; scarcity",
  },
  { word: "peak", wordInfo: "the highest or most important point" },
  { word: "peripheral", wordInfo: "located on the side or edge" },
  { word: "permeate", wordInfo: "to penetrate or pass through" },
  {
    word: "persist",
    wordInfo: "to continue, especially when facing opposition",
  },
  { word: "pertain", wordInfo: "to relate" },
  { word: "phase", wordInfo: "a period or stage in a process" },
  { word: "poll", wordInfo: "a record of opinions or votes" },
  { word: "potent", wordInfo: "powerful" },
  { word: "pragmatic", wordInfo: "practical, sensible" },
  { word: "praise", wordInfo: "to give approval or admiration" },
  { word: "precede", wordInfo: "to come before" },
  { word: "precise", wordInfo: "exact" },
  { word: "prestigious", wordInfo: "having a high reputation" },
  { word: "prevalent", wordInfo: "widespread" },
  { word: "primary", wordInfo: "first; most important" },
  { word: "prior", wordInfo: "previous or earlier" },
  { word: "proceed", wordInfo: "to continue doing something" },
  { word: "progeny", wordInfo: "offspring" },
  { word: "promote", wordInfo: "to further the progress of something" },
  { word: "prosper", wordInfo: "to do well" },
  { word: "proximity", wordInfo: "nearness in time or space" },
  { word: "quarrel", wordInfo: "a disagreement or fight" },
  {
    word: "range",
    wordInfo: "the distance between two things, often the maximum and",
  },
  { word: "rank", wordInfo: "an official position or station" },
  { word: "rebuke", wordInfo: "to sternly disapprove or reprimand" },
  { word: "recapitulate", wordInfo: "to give a brief summary" },
  { word: "recede", wordInfo: "to retreat" },
  {
    word: "recommend",
    wordInfo: "to present someone with confidence and approval",
  },
  { word: "reform", wordInfo: "to make changes that improve something" },
  {
    word: "regulate",
    wordInfo:
      "to supervise or control a process so that it functions correctly",
  },
  { word: "reinforce", wordInfo: "to strengthen with added support" },
  { word: "reject", wordInfo: "to say no to something that is offered" },
  { word: "release", wordInfo: "to free" },
  { word: "rely", wordInfo: "to depend on" },
  { word: "reproach", wordInfo: "to express disapproval or disappointment" },
  { word: "require", wordInfo: "to need for a specific purpose" },
  {
    word: "resent",
    wordInfo: "to feel bitterness or anger towards someone or something",
  },
  { word: "resign", wordInfo: "to give up an office or position" },
  { word: "resist", wordInfo: "to withstand the effect of" },
  { word: "resolve", wordInfo: "to come to a firm decision" },
  { word: "restrict", wordInfo: "to confine or keep within limits" },
  { word: "retain", wordInfo: "to continue to do something or keep something" },
  { word: "retract", wordInfo: "to draw back in" },
  { word: "retrieve", wordInfo: "to bring back" },
  { word: "rhetorical", wordInfo: "used just for style or impact" },
  { word: "rigid", wordInfo: "stiff, unyielding" },
  { word: "rotate", wordInfo: "to turn" },
  {
    word: "safeguard",
    wordInfo: "something that serves as protection or ensures safety",
  },
  { word: "scrutinize", wordInfo: "to very carefully examine" },
  { word: "section", wordInfo: "a part of the whole" },
  { word: "select", wordInfo: "to choose" },
  {
    word: "sequence",
    wordInfo: "things that follow each other in a certain order",
  },
  { word: "severe", wordInfo: "harsh or strict" },
  { word: "shallow", wordInfo: "not deep" },
  { word: "shelter", wordInfo: "to protect from something harmful" },
  { word: "shrink", wordInfo: "to become smaller" },
  { word: "significant", wordInfo: "important, noteworthy" },
  {
    word: "source",
    wordInfo: "a person, place or thing where something was obtained",
  },
  { word: "sparse", wordInfo: "thinly scattered" },
  { word: "specify", wordInfo: "to clearly specify which one" },
  { word: "speculate", wordInfo: "to form a theory without strong evidence" },
  { word: "solitary", wordInfo: "alone; without others" },
  { word: "somber", wordInfo: "gloomy; depressing" },
  { word: "soothe", wordInfo: "to calm or comfort" },
  { word: "squalid", wordInfo: "filthy and unpleasant" },
  { word: "stable", wordInfo: "unlikely to change or fail" },
  { word: "stagnant", wordInfo: "sluggish; showing little movement" },
  { word: "strategy", wordInfo: "a plan to reach a desired outcome" },
  { word: "subsequent", wordInfo: "coming after something in time" },
  {
    word: "substitute",
    wordInfo: "a person or thing acting in place of another",
  },
  { word: "subtle", wordInfo: "difficult to notice right away" },
  { word: "sufficient", wordInfo: "enough to serve a particular purpose" },
  { word: "summarize", wordInfo: "to briefly give the main points" },
  { word: "supervise", wordInfo: "to oversee work or a process" },
  { word: "supplant", wordInfo: "to take the place of something else" },
  { word: "suspend", wordInfo: "to temporarily stop" },
  {
    word: "suspicious",
    wordInfo: "having the belief that someone is doing something dishonest",
  },
  { word: "sustain", wordInfo: "to keep going" },
  { word: "symbolic", wordInfo: "serving as a symbol" },
  { word: "technical", wordInfo: "relating to a specific subject or craft" },
  { word: "terminal", wordInfo: "situated at the end" },
  { word: "tolerate", wordInfo: "to put up with" },
  { word: "transfer", wordInfo: "to move from one place to another" },
  {
    word: "transition",
    wordInfo: "to change from one state or condition to another",
  },
  { word: "transparent", wordInfo: "easy to see through" },
  { word: "tuition", wordInfo: "the fee for instruction at a school" },
  { word: "unobtrusive", wordInfo: "not attracting attention" },
  { word: "unscathed", wordInfo: "unharmed" },
  { word: "upbeat", wordInfo: "happy, optimistic" },
  { word: "unjust", wordInfo: "unfair" },
  { word: "vacillate", wordInfo: "to waver or be indecisive" },
  { word: "valid", wordInfo: "just; well-founded" },
  { word: "vanish", wordInfo: "to disappear quickly" },
  { word: "vary", wordInfo: "to be different from something else in a group" },
  { word: "verdict", wordInfo: "a judgement or decision" },
  {
    word: "vestige",
    wordInfo: "a small trace of something that is disappearing or has already",
  },
  { word: "vial", wordInfo: "a small container used to hold liquids" },
  { word: "vilify", wordInfo: "to speak poorly of; to slander" },
  { word: "voluminous", wordInfo: "taking up a lot of space" },
  { word: "whereas", wordInfo: "on the contrary" },
  { word: "wholly", wordInfo: "completely" },
  { word: "widespread", wordInfo: "occurring over a large region" },
  { word: "wilt", wordInfo: "to droop and become limp" },
];
